import { JobCard } from "@/components/Jobs/JobCard";
import { IJob } from "@/hooks/useJobs";
import type { SharedJob } from "@/components/Sharing/types";

type JobListProps =
  | { variant?: "owned"; jobs: IJob[] }
  | { variant: "shared"; jobs: SharedJob[] };

export const JobList = (props: JobListProps) => {
  return (
    <div className="w-full" data-testid="job-list">
      {props.variant === "shared"
        ? props.jobs.map((job) => (
            <JobCard variant="shared" job={job} key={job.jobId} />
          ))
        : props.jobs.map((job) => <JobCard job={job} key={job.jobId} />)}
    </div>
  );
};
